import { render, staticRenderFns } from "./BalanceListBlockItem.vue?vue&type=template&id=37d835fa&scoped=true&"
import script from "./BalanceListBlockItem.vue?vue&type=script&lang=js&"
export * from "./BalanceListBlockItem.vue?vue&type=script&lang=js&"
import style0 from "./BalanceListBlockItem.vue?vue&type=style&index=0&id=37d835fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d835fa",
  null
  
)

export default component.exports